import { useState } from "react";
import { C } from "./const";
import SectionBadge from "./IntroSectionBadge";
import SectionTitle from "./IntroSectionTitle";
const FAQS = [
    {
        q: "چگونه می‌توانم استعلام قیمت بگیرم؟",
        a: "کافیست فرم تماس را پر کنید یا با شماره مستقیم ما تماس بگیرید. کارشناسان ما ظرف ۲ ساعت با شما تماس می‌گیرند.",
    },
    {
        q: "مدت زمان صدور بیمه‌نامه چقدر است؟",
        a: "بیمه‌نامه‌های خودرو در همان روز صادر می‌شوند. سایر بیمه‌نامه‌ها حداکثر ۲۴ ساعت زمان می‌برند.",
    },
    {
        q: "آیا امکان پرداخت اقساطی وجود دارد؟",
        a: "بله، برای اکثر بیمه‌نامه‌ها امکان پرداخت ۳، ۶ و ۱۲ ماهه وجود دارد.",
    },
    {
        q: "در صورت بروز خسارت چه باید بکنم؟",
        a: "با خط اضطراری ۲۴ ساعته ما تماس بگیرید. کارشناس خسارت در اسرع وقت اعزام می‌شود.",
    },
];

const IntroFaqs = () => {

    const [openFaq, setOpenFaq] = useState<number | null>(null);

    return (

        <section id="faq" style={{ background: C.white, padding: "80px 24px" }}>
            <div style={{ maxWidth: 780, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 52 }}>
                    <SectionBadge text="سوالات متداول" />
                    <SectionTitle center>پاسخ به سوالات شما</SectionTitle>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {FAQS.map((faq, i) => {
                        const isOpen = openFaq === i;
                        return (
                            <div
                                key={i}
                                style={{
                                    border: `1px solid ${isOpen ? C.primary : C.border}`,
                                    borderRadius: 14,
                                    overflow: "hidden",
                                    transition: "border-color .2s",
                                }}
                            >
                                <button
                                    onClick={() => setOpenFaq(isOpen ? null : i)}
                                    style={{
                                        width: "100%",
                                        background: isOpen ? C.primaryLight : C.white,
                                        border: "none",
                                        padding: "18px 22px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        textAlign: "right",
                                        transition: "background .2s",
                                    }}
                                >
                                    <span style={{ fontWeight: 700, color: C.primaryDark, fontSize: 15 }}>
                                        {faq.q}
                                    </span>
                                    <span
                                        style={{
                                            color: C.primary,
                                            fontSize: 20,
                                            fontWeight: 700,
                                            flexShrink: 0,
                                            marginRight: 12,
                                            transition: "transform .25s",
                                            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                                            display: "inline-block",
                                        }}
                                    >
                                        +
                                    </span>
                                </button>

                                {isOpen && (
                                    <div
                                        style={{
                                            padding: "0 22px 20px",
                                            background: C.primaryLight,
                                            color: C.gray,
                                            fontSize: 14,
                                            lineHeight: 1.85,
                                        }}
                                    >
                                        {faq.a}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
export default IntroFaqs;